import { Component, Input } from '@angular/core';
import { environment } from '@environments/environment';
import { TranslateService } from '@services/translate.service';
import { LocalizationService } from '@services/localization.service';
import { SignOutDialog } from '@app/dialogs/sign-out.dialog';
import { MatDialog } from '@angular/material/dialog';
import { DataHelper } from '@helpers/data.helper';
import { UserHelper } from '@helpers/user.helper';
import { Router } from '@angular/router';

@Component({
  selector: 'account-menu-component',
  templateUrl: './account-menu.component.html',
})
export class AccountMenuComponent {
  accountTabMenu;
  constructor(
    public _LocalizationService: LocalizationService,
    private _TranslateService: TranslateService,
    public _MatDialog: MatDialog,
    public _DataHelper: DataHelper,
    public _UserHelper: UserHelper,
    public _Router: Router
  ) {
    this.accountTabMenu = {
      Slip_Bets: {
        route: '/account/bet-slip',
        routeKey: 'bet-slip',
        title: this._TranslateService.instant('Slip_Bets'),
        tabId: 1,
        extraClass: '',
        bannedProject: [], // projede kaldırılmak isteniyorsa buraya proje ismi eklenmeli
        ngIf: () => true,
        order: 1,
        icon: 'bets-account',
        iconClass: '',
        rightMenuIsShow: ['p1012'], // projede right-menu de gözükmesi isteniyorsa proje ismi eklenmeli (bannedProject ve ngIf kontrollerinden geçtikten sonra kontrol edilir)
      },
      ArenaPay: {
        route: '/account/pay3000',
        routeKey: 'pay3000',
        title: '',
        tabId: 10,
        extraClass: '',
        bannedProject: ['p1012'],
        ngIf: () => false,
        order: 2,
        icon: 'coins',
        iconClass: 'svg-coins',
        rightMenuIsShow: [],
      },
      Credit: {
        route: '/account/credit',
        routeKey: 'credit',
        title: this._TranslateService.instant('deposit_and_withdraw'),
        tabId: 2,
        extraClass: '',
        bannedProject: ['p1012'],
        ngIf: () => true,
        order: 3,
        icon: 'coins',
        iconClass: 'svg-coins',
        rightMenuIsShow: [],
      },
      Bookings: {
        route: '/account/bookings',
        routeKey: 'bookings',
        title: this._TranslateService.instant('bookings'),
        tabId: 3,
        extraClass: '',
        bannedProject: [],
        ngIf: () => this._DataHelper.selectedWallet.BranchType !== 5,
        order: 4,
        icon: 'bets-time-account',
        iconClass: 'svg-account-icon',
        rightMenuIsShow: [],
      },
      CASHBACK: {
        route: '/account/cashback',
        routeKey: 'cashback',
        title: this._TranslateService.instant('CASHBACK'),
        tabId: 4,
        extraClass: '',
        bannedProject: [],
        ngIf: () => this._DataHelper.selectedWallet.BranchType !== 5,
        order: 5,
        icon: 'info-circle',
        iconClass: 'svg-info-circle',
        rightMenuIsShow: ['p1012'],
      },
      Bonus: {
        route: '/account/bonus',
        routeKey: 'bonus',
        title: this._TranslateService.instant('Bonus'),
        tabId: 9,
        extraClass: '',
        bannedProject: [],
        ngIf: () => true,
        order: 6,
        icon: 'account',
        iconClass: 'svg-account-icon',
        rightMenuIsShow: ['p1012'],
      },
      User_Profile: {
        route: '/account/profile',
        routeKey: 'profile',
        title: this._TranslateService.instant('User_Profile'),
        tabId: 5,
        extraClass: '',
        bannedProject: [],
        ngIf: () => this._DataHelper.selectedWallet.BranchType !== 5,
        order: 7,
        icon: 'user-account',
        iconClass: 'svg-user-icon',
        rightMenuIsShow: ['p1012'],
      },
      limits_bans: {
        route: '/account/limit',
        routeKey: 'limit',
        title: this._TranslateService.instant('limits_bans'),
        tabId: 6,
        extraClass: '',
        bannedProject: [],
        ngIf: () => this._DataHelper.selectedWallet.BranchType !== 0 && this._DataHelper.selectedWallet.BranchType !== 5,
        order: 8,
        icon: 'lock',
        iconClass: 'svg-lock',
        rightMenuIsShow: ['p1012'],
      },
      document_upload: {
        title: this._TranslateService.instant('document_upload'),
        route: '/account/document-upload',
        routeKey: 'document-upload',
        tabId: 7,
        extraClass: '',
        bannedProject: [],
        ngIf: () => this._DataHelper.selectedWallet.BranchType !== 5,
        order: 9,
        icon: 'file',
        iconClass: 'svg-file-icon',
        rightMenuIsShow: ['p1012'],
      },
      document_download: {
        route: '/account/document-download',
        routeKey: 'document-download',
        title: this._TranslateService.instant('Document_Download'),
        tabId: 11,
        extraClass: '',
        bannedProject: [],
        ngIf: () => false,
        order: 11,
        icon: 'file',
        iconClass: 'svg-file-icon',
        rightMenuIsShow: [],
      },
      Verifications: {
        route: '/account/verifications',
        routeKey: 'verifications',
        title: this._TranslateService.instant('Verifications'),
        tabId: 8,
        extraClass: '',
        bannedProject: [],
        ngIf: () => this._DataHelper.selectedWallet.BranchType == 1,
        order: 10,
        icon: 'verification',
        iconClass: 'svg-file-icon',
        rightMenuIsShow: [],
      },
      Verifications_pl: {
        title: this._TranslateService.instant('Verifications', null),
        tabId: 7,
        extraClass: '',
        bannedProject: ['p1012'],
        ngIf: () => this._DataHelper.selectedWallet.BranchType == 1,
        order: 9,
        icon: 'verification',
        iconClass: 'svg-file-icon',
        rightMenuIsShow: [],
      },
      Verification_SOW: {
        route: '/account/creditworthiness',
        routeKey: 'creditworthiness',
        title: this._TranslateService.instant('Verification_SOW'),
        tabId: 11,
        extraClass: '',
        bannedProject: [],
        ngIf: () => false && this._DataHelper.selectedWallet.BranchType == 1,
        order: 11,
        icon: 'creditworthiness',
        iconClass: 'svg-file-icon',
        rightMenuIsShow: [],
      },
      My_Messages: {
        route: '/account/my-messages',
        routeKey: 'my-messages',
        title: 'My Messages',
        tabId: 1,
        extraClass: '',
        bannedProject: [], // projede kaldırılmak isteniyorsa buraya proje ismi eklenmeli
        ngIf: () => true,
        order: 14,
        icon: 'message-black',
        iconClass: '',
        rightMenuIsShow: ['p1012'],
      },
    };
  }

  @Input() menuSelect: string;
  @Input() userHelper: any;
  @Input() UiHelper: any;

  accountTabMenuRebuild(
    values: {
      [key: string]: {
        title: string;
        route: string;
        routeKey: string;
        tabId: number;
        extraClass: string;
        bannedProject: string[];
        ngIf: () => boolean;
        order: number;
        rightMenuIsShow: string[];
        icon: string;
        iconClass: string;
      };
    },
    isRightMenu = false
  ) {
    return Object.values(values)
      .filter(item =>
        isRightMenu
          ? item.ngIf() && !item.bannedProject.includes(environment.product) && item.rightMenuIsShow.includes(environment.product)
          : item.ngIf() && !item.bannedProject.includes(environment.product)
      )
      .sort((a, b) => a.order - b.order);
  }

  SignOutDialogOpener(x) {
    const dialogRef = this._MatDialog;
    if (x) {
      this.UiHelper.closeAllMenus();
      dialogRef.open(SignOutDialog, {
        width: '350px',
      });
    } else {
      dialogRef.closeAll();
    }
  }

  public routeTo(route: string) {
    this.UiHelper.SetRightMenuState('close');
    this._Router.navigate([route]);
  }
}
